import React, { useState, useEffect, useRef } from "react";
import { Navigate, useLocation, useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import "../../admin_tools.css";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import BackIcon from "../../../../assets/communication/Back.svg";
import { ADMIN_TOOLS_CARES_ACCESSORY } from "../../../../routes";
import { Loader } from "@progress/kendo-react-indicators";
import { EcardAccessoryForm} from "./form";
import { saveEcardAccessoryStickers } from "../../../../store/ecards";

export const AddEcardAccessory = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  useEffect(() => {}, []);

  const handleSaveAccessory = ({name,url}) => {
    let payload = {
      name,
      url
    }
    console.log(payload);
    dispatch(saveEcardAccessoryStickers(payload)).then((response) => {
      setLoading(false);
      console.log("handleSaveAccessory response:", response);
      navigate(ADMIN_TOOLS_CARES_ACCESSORY);
    });
  };
  return (
    <>
      <div className="detail-body">
        {loading ? (
          <Loader
            type="infinite-spinner"
            style={{
              display: "flex",
              alignItems: "center",
              width: "40px",
              margin: "auto",
              justifyContent: "center",
              height: "100vh",
            }}
          />
        ) : (
          <>
            <div className="detail-header">
              <div
                className="categoryback-group-div"
                onClick={() => navigate(ADMIN_TOOLS_CARES_ACCESSORY)}
              >
                <img src={BackIcon} className="categoryback-icon" />
                <span className="categoryback-label">Back</span>
              </div>
            </div>
            <div className="detail-content">
              <EcardAccessoryForm
                data={null}
                isEdit={true}
                isCreate={true}
                submitForm={handleSaveAccessory}
                setLoading={setLoading}
              />
            </div>
          </>
        )}
      </div>
    </>
  );
};
